import Vue from 'vue'
import Router from 'vue-router'
import store from "../store";

import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import SignUp from '@/components/SignUp'
import Profile from '@/components/Profile'
import Detail from '@/components/Detail'
import Terms from '@/components/Terms'
import User from '@/components/User'
import Users from '@/components/Users'
import Admin from '@/components/Admin'
import PoolsGrid from '@/components/Pools-grid'
import PoolDetail from '@/components/Pool-form'
import PoolNew from '@/components/Pool-new'
import Poolcomm from '@/components/Poolcomm'
import firebase from 'firebase/app'
import UserUnsubscribe from '@/components/UserUnsubscribe' 
import AlexaLogin from '@/components/AlexaLogin' //To authenticate Alexa assistant users only
import Demo from '@/components/Demo'
import Query from '@/components/Query-panel'
import Autosat from '@/components/Autosat'


Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/dashboard'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/deleteaccount',
      name: 'deleteaccount',
      component: UserUnsubscribe
    },
    {
      path: '/alexalogin',
      name: 'alexalogin',
      component: AlexaLogin
    },
    {
      path: '/legal/',
      name: 'Legal',
      component: Terms
    },
    {
      path: '/legal/:lang',
      name: 'Legal',
      component: Terms
    },
    {
      path: '/autosat/',
      name: 'Autosat',
      component: Autosat
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/detail/:poolId',
      name: 'Detail',
      component: Detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user-detail/:userId',
      name: 'User',
      component: User,
      beforeEnter: checkRole,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/poolcomm',
      name: 'Poolcomm',
      component: Poolcomm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: checkRole,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/pools',
      name: 'Pools',
      component: PoolsGrid,
      beforeEnter: checkRole,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pool-detail/:poolId',
      name: 'PoolDetail',
      component: PoolDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pool-new',
      name: 'PoolNew',
      beforeEnter: checkRole,
      component: PoolNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: checkRoleSuper,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/demo/',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/query/',
      name: 'Query',
      component: Query,
      beforeEnter: checkRoleSuper,
      meta: {
        requiresAuth: true
      }
    },
  ]
})

function checkRole(to, from, next) {
  function proceed() {
    if (store.state.userProfile && store.state.userProfile.role) {
      let role = store.state.userProfile.role;
      if(role=='admin' || role=='superadmin'){
        next()
      } else {
        console.log('not authorized')
        next({ name: 'Dashboard'})
      }
      
    }
  }
  if (!store.state.userProfile.role) {
    store.watch(store.getters.getUser, function () {
      proceed();
    });
  } else {
    proceed()
  }
}


function checkRoleSuper(to, from, next) {
  function proceed() {
    if (store.state.userProfile && store.state.userProfile.role) {
      let role = store.state.userProfile.role;
      if(role=='superadmin'){
        next()
      } else {
        console.log('not authorized')
        next({ name: 'Dashboard'})
      }
      
    }
  }
  if (!store.state.userProfile.role) {
    store.watch(store.getters.getUser, function () {
      proceed();
    });
  } else {
    proceed()
  }
}

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  // let verifiedEmail = (currentUser) ? currentUser.emailVerified : false;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let domain = window.location.pathname;
  store.state.host = domain

  if (requiresAuth && (!currentUser)) {
    next({ name: 'Login', query: { from: domain }});
    // else if (!requiresAuth && currentUser) next('Dashboard')
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js